class WishlistGenericModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.cancelClicked = this.cancelClicked.bind(this)
    this.els.cancel.element.addEventListener('click', this.cancelClicked)

    this.continueClicked = this.continueClicked.bind(this)
    this.els.continue.element.addEventListener('click', this.continueClicked)
  }

  cancelClicked (e) {
    window.BAO.wishlist.genericModalCancel()
  }

  continueClicked (e) {
    window.BAO.wishlist.genericModalContinue()
  }
}

customElements.define('wishlist-generic-modal', WishlistGenericModal)
